import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

// style rules
import { Colors, Typography, Sizes } from "../../styles";

const TabItem = ({ filter, isActive, handleFilterSelect }) => {

	return (
		<FilterWrapper
			onClick={() => handleFilterSelect(filter)}
		>
			<Filter isActive={isActive}>{filter.title}</Filter>
		</FilterWrapper>
	);
};

TabItem.propTypes = {
	filter: PropTypes.object,
	isActive: PropTypes.bool,
	handleFilterSelect: PropTypes.func,
};

export default TabItem;

const FilterWrapper = styled(motion.li)`
	margin: 0;
	padding: 0;
	list-style: none;
`;

const Filter = styled.button`
	cursor: pointer;
	background: none;
	border: none;
	padding: 1.5rem 1rem;
	font-size: 1.3rem;
	line-height: 1.8rem;
	letter-spacing: -0.016em;
	font-weight: ${Typography.fontWeight.bold};
	position: relative;
	display: inline-block;
	color: ${(props) => (props.isActive ? Colors.base.black : Colors.base.white)};
	border-radius: 30px;
	border: 3px solid ${Colors.fp.pineGreen40};
	background-color: ${(props) =>
		props.isActive ? Colors.fp.pineGreen40 : "transparent"};
	white-space: unset;
	word-wrap: break-word;
	height: 100%;
	width: 100%;

	&:hover,
	&:focus {
		padding-right: 2rem;
		color: ${Colors.base.black};
		background-color: ${Colors.fp.pineGreen40};

		&::after {
			all: unset;
		}
	}

	@media only screen and (min-width: ${Sizes.screens.medium}) {
		font-size: 1.6rem;
		padding: 2rem;
		white-space: pre;
		height: unset;
		width: unset;
	}
`;
